import React, { createContext, useContext, useState } from 'react';

const FridgeScanContext = createContext();

export function FridgeScanProvider({ children }) {
  const [result, setResult] = useState(null);
  const [phase, setPhase] = useState('upload');
  const [savedMap, setSavedMap] = useState({});

  function clearScan() {
    setResult(null);
    setPhase('upload');
    setSavedMap({});
  }

  return (
    <FridgeScanContext.Provider value={{ result, setResult, phase, setPhase, savedMap, setSavedMap, clearScan }}>
      {children}
    </FridgeScanContext.Provider>
  );
}

export function useFridgeScan() {
  return useContext(FridgeScanContext);
}
